const ENV = process.env.NODE_ENV || 'development';

const environments = {
   development: {
      logLevel: 'debug',
      apiMocks: true,
   },
   test: {
      logLevel: 'error',
      apiMocks: true,
   },
   production: {
      logLevel: 'error',
      apiMocks: false,
   },
};

export const ENV_CONFIG = environments[ENV] || environments.development;
